import * as AuthActions from '../../actions/auth';
import { reducer } from '../reducerUtils';

const initialState = {
  requestingLogin: false,
  requestingLogout: false,
  loginFailed: false,
  requestingUser: false,
  isAuthenticated: false,
  error: '',
  user: {},
  authenticationFailure: false,
  updateAvailable: false,
  forcedUserLogOut: false,
};

export default reducer({
  [AuthActions.LOGIN_REQUEST]: (state, action) => ({
    ...state,
    requestingLogin: action.payload,
    authenticationFailure: action.payload || false,
  }),
  [AuthActions.LOGIN_SUCCESS]: (state) => ({
    ...state,
    isAuthenticated: true,
    requestingLogin: false,
    authenticationFailure: false,
    error: '',
  }),
  [AuthActions.LOGIN_FAILURE]: (state, action) => ({
    ...state,
    error: action.payload.error,
    requestingLogin: false,
    loginFailed: true,
  }),
  [AuthActions.LOGOUT_REQUEST]: (state) => ({
    ...state,
    requestingLogout: true,
  }),
  [AuthActions.UPDATE_AVAILABLE]: (state) => ({
    ...state,
    requestingLogin: false,
    updateAvailable: true,
    loginFailed: true,
  }),
  [AuthActions.LOGOUT_SUCCESS]: (state) => ({
    ...state,
    requestingLogout: false,
    isAuthenticated: false,
    authenticationFailure: true,
    loginFailed: false,
    user: {},
  }),
  [AuthActions.LOGOUT_FAILURE]: (state, action) => ({
    ...state,
    requestingLogout: false,
    error: action.payload.error,
  }),
  [AuthActions.RETRIEVE_USER_REQUEST]: (state) => ({
    ...state,
    requestingUser: true,
  }),
  [AuthActions.RETRIEVE_USER_SUCCESS]: (state, action) => ({
    ...state,
    requestingUser: false,
    user: action.payload,
  }),
  [AuthActions.RETRIEVE_USER_FAILURE]: (state, action) => ({
    ...state,
    requestingUser: false,
    error: action.payload.error,
  }),
  [AuthActions.SET_AUTH_ERROR_MESSAGE]: (state, action) => ({
    ...state,
    error: action.payload.error,
  }),
  [AuthActions.AUTH_FAILURE]: (state) => ({
    ...state,
    authenticationFailure: true,
  }),
  [AuthActions.FORCED_USER_LOG_OUT]: (state, action) => ({
    ...state,
    forcedUserLogOut: action.payload,
  }),
}, initialState);
